<template>
  <div>
    <v-card>
      <v-container grid-list-lg>
        <v-layout class="ma-2" align-center="align-center" justify-center row>
          <div class="text-center">
            <h1 class="font-weight-light display-3">Bill Payment</h1>
            <h1 class="headline">The wireless industry spends over</h1>
            <div class="text-center mt-3 font-weight-medium">
              <div>
                <span class="display-2 font-weight-black red--text">$200 MILLION </span>
                <span class="font-weight-medium">a year to keep their customers.</span>
              </div>
              <div>Retaining customers is the biggest problem in the cell phone business.</div>
              <div>
                Never miss out on future customer payments - keep your customers in the loop by
                sending them bill payment reminders with your own personalized text message every
                month, <span>no extra cost</span>
              </div>
              <div>Don’t just sell, CellSmart!</div>
              <div class="mt-3 font-weight-medium">
                Below are the key features of the Repair module, click any feature to view details:
              </div>
            </div>
          </div>
        </v-layout>
        <v-layout class="mt-3" row wrap>
          <v-flex xs12 sm4="sm4" md3="md3" v-for="item in items">
            <v-tooltip top="top">
              <div slot="activator" :active-click="true" width="100%" height="200px">
                <div class="text-center" slot="front">
                  <v-container>
                    <img :src="item.img" width="60" />
                    <h3 class="h3-header">{{ item.title }}</h3>
                  </v-container>
                </div>
                <div slot="back">
                  <v-card dark="dark">
                    <v-container>
                      <div class="text-center">
                        <img :src="item.img" width="60" />
                        <div>{{ item.detail }}</div>
                      </div>
                    </v-container>
                  </v-card>
                </div>
              </div>
              <span>Click for detail</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
        <v-divider> </v-divider>
        <v-card-actions class="mt-3">
          <v-layout row wrap>
            <v-layout column>
              <h2 class="h2-header">All that for Only {{ price | currency }} a month</h2>
              <div>added to your monthly plan</div>
            </v-layout>
            <v-spacer> </v-spacer>
            <v-btn color="blue darken-1" large text @click="removeDeal">{{
              $t("buttons.noThanks")
            }}</v-btn>
            <v-btn color="blue darken-1" large dark="dark" @click="save">{{
              $t("buttons.addFeature")
            }}</v-btn>
          </v-layout>
        </v-card-actions>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      showQuestion: true,
      price: 15,
      name: "Bill Payment",
      items: [
        {
          img: require("../../../../assets/upSale/smartphone1.png"),
          title: "Payment Text Message",
          detail:
            "Customers will receive text message alerts informing them when their bill is due and again once payment has been received"
        },
        {
          img: require("../../../../assets/upSale/tax.png"),
          title: "Multiple Tax",
          detail: "Collect different taxes in onesingle bill payment."
        },
        {
          img: require("../../../../assets/upSale/keypad.png"),
          title: "Pin Number",
          detail: "Save each customers pin number and retrieve it at the time of payment."
        },
        {
          img: require("../../../../assets/upSale/list.png"),
          title: "Payment History",
          detail: "Employees has access to detailed records of customers payments."
        },
        {
          img: require("../../../../assets/upSale/reminder.png"),
          title: "Payment Reminder",
          detail: "Send customers a custom message as a reminder of payment due date."
        },
        {
          img: require("../../../../assets/upSale/policy.png"),
          title: "Custom Policy",
          detail:
            "Create your own individual repair policy that can be different from that of the sales or bill payments policy."
        },
        {
          img: require("../../../../assets/upSale/invoice.png"),
          title: "Bill Payment Fee",
          detail:
            "Let customers know how much their bill payment will be including the carrier fee or your fee."
        },
        {
          img: require("../../../../assets/upSale/payment-method.png"),
          title: "Payment Installment",
          detail:
            "Not every customer can pay for a repair job all at once, now you can collect the payments in installments."
        },
        {
          img: require("../../../../assets/upSale/translate.png"),
          title: "Language",
          detail: "Print receipts and send text message alerts in both English or Spanish."
        },
        {
          img: require("../../../../assets/upSale/report.png"),
          title: "Reports",
          detail:
            "Bill Payment comes with custom reporting which allows employees to view and filter records of payments by providers."
        },
        {
          img: require("../../../../assets/upSale/epay.png"),
          title: "ePay Integrations",
          detail: "Make the CellSmart POS your one stop for ePay Bill Payments."
        },
        {
          img: require("../../../../assets/upSale/qpay.png"),
          title: "Qpay Integrations",
          detail: "Pay Metro PCS Customer bills with Qpay integrations."
        },
        {
          img: require("../../../../assets/upSale/vidapay.png"),
          title: "Vida Pay Integrations",
          detail: "Make the CellSmart POS your one stop for VidaPay Bill Payments."
        }
      ]
    };
  },
  methods: {
    ...mapActions("location", ["feature", "removeDeal"]),
    save() {
      this.feature({
        id: 3,
        feature: this.name,
        price: this.price
      });
    }
  }
};
</script>

<style scoped></style>
